module.exports = __webpack_public_path__ + "static/media/hand-left-front.c6942992.png";